module.exports = __webpack_public_path__ + "static/media/coins-message-icon.225407c8.png";